import { doc, updateDoc, getFirestore } from 'firebase/firestore';
import { COLLECTIONS } from '../constants';

const db = getFirestore();

export const updateFirestoreItem = async (
  id: string,
  newData: Record<string, any>,
  collection: string = COLLECTIONS.listings,
) => {
  const itemRef = doc(db, collection, id);
  await updateDoc(itemRef, newData);
};
